"use client";

import { House } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHomes() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="our-homes" ref={sectionRef} className="w-full bg-muted py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className={`mb-12 text-center text-3xl font-bold text-accent md:text-4xl ${sectionVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          Our Homes
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {}
          <Card ref={card1Ref} className={`group overflow-hidden border border-border bg-white shadow-soft transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:shadow-medium ${card1Visible ? "animate-fade-in-up" : "opacity-0"}`}>
            <img src="https://composed-gull.10web.cloud/wp-content/uploads/2026/01/ChatGPT-Image-Nov-20-2025-07_39_56-PM.png" alt="Marsland House" className="h-64 w-full rounded-t-lg object-cover" />
            <CardContent className="space-y-4 p-6">
              <h3 className="text-xl font-bold text-accent">Thrive Billinge Road</h3>
              <p className="text-foreground leading-relaxed"><strong data-start="152" data-end="275">Thrive House is a calm, nurturing home in Wigan where children can settle, feel safe, and build trusting relationships.</strong> We keep routines predictable, spaces sensory-aware, and support consistent—so day-to-day life feels stable, not chaotic.</p>
              <Link to="#" className="inline-flex items-center font-semibold text-accent transition-colors hover:text-accent-hover">
                View House →
              </Link>
            </CardContent>
          </Card>

          {}
          <Card ref={card2Ref} className={`group overflow-hidden border border-border shadow-soft transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:shadow-medium ${card2Visible ? "animate-fade-in-up-delay-100" : "opacity-0"}`} style={{
          background: "linear-gradient(135deg, hsl(80, 70%, 55%) 0%, hsl(80, 70%, 38%) 100%)"
        }}>
            <CardContent className="flex h-full min-h-[400px] flex-col items-center justify-center space-y-6 p-6">
              <House className="h-24 w-24 text-white" strokeWidth={1.5} />
              <h3 className="text-2xl font-bold text-white">COMING SOON</h3>
              <p className="text-center text-white/90 leading-relaxed">
                We are expanding our services with a new supported living home. 
                Stay tuned for more details about this exciting addition to our community.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}